const ChatbotIcon = ({ className = "hayley-h-9 hayley-w-9", viewBox = "0 0 36 36" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <circle cx="18" cy="18" r="17" stroke="#00A5DD" strokeWidth="2" />
      <path
        d="M28.9232 17.2617C28.9232 22.8134 28.0552 27.6901 23.8417 29.8368C23.7217 29.8982 23.5989 29.9578 23.4734 30.0137C22.5533 30.4288 21.4844 30.7233 20.2445 30.8763C19.5968 30.9569 18.9015 30.999 18.156 31H18.131C18.0871 31 18.0441 30.999 18.0002 30.998C17.9563 30.999 17.9133 31 17.8685 31H17.8425C17.0981 30.999 16.4029 30.9569 15.7551 30.8763C14.5152 30.7232 13.4463 30.4288 12.526 30.0137C12.4007 29.9568 12.2778 29.8974 12.1579 29.836C7.94449 27.6891 7.07617 22.8126 7.07617 17.2617C7.07617 10.6576 10.4906 6.15686 15.567 5.19447C16.2407 5.06568 16.943 5 17.6714 5C17.7289 5 17.785 5.00089 17.8424 5.00089C17.8952 5.00267 17.9472 5.00346 18.0001 5.00523C18.052 5.00346 18.104 5.00267 18.156 5.00089C18.2134 5.00089 18.2707 5 18.328 5C19.0564 5 19.7588 5.06568 20.4325 5.19447C25.5089 6.15686 28.9232 10.6575 28.9232 17.2617Z"
        fill="url(#paint0_radial_456_344)"
      />
      <path
        d="M25.5803 26.0385L25.5694 26.0707L24.3556 26.3071C24.3501 26.6237 24.2964 28.4935 23.765 29.913C23.6952 29.9357 23.6245 29.9576 23.5527 29.9784C24.1503 28.4518 24.1764 26.2935 24.1773 26.2654V26.2235L25.4146 25.9827C25.6036 25.3284 25.5784 22.6936 25.5775 22.6666L25.7567 22.666C25.7584 22.779 25.7835 25.4324 25.5803 26.0385Z"
        fill="#ABB1B8"
      />
      <path
        d="M11.8244 26.2654C11.8255 26.2935 11.8514 28.4512 12.4489 29.9778C12.3774 29.957 12.3065 29.935 12.2367 29.9124C11.7054 28.4929 11.6516 26.6237 11.6463 26.3071L10.4323 26.0707L10.4216 26.0385C10.2181 25.4324 10.2433 22.779 10.245 22.666L10.4242 22.6666C10.4233 22.6936 10.3981 25.3284 10.5873 25.9827L11.8244 26.2235V26.2654V26.2654Z"
        fill="#ABB1B8"
      />
      <path
        d="M18.0884 5.00391V30.9999H17.9092V5.00391C17.9387 5.00391 17.9692 5.00479 17.9988 5.00568C18.0283 5.00479 18.0588 5.00391 18.0884 5.00391Z"
        fill="#ABB1B8"
      />
      <path
        d="M13.4015 24.1206H22.6026C25.7708 24.1206 28.4194 21.5481 28.917 18.2045C28.8672 16.3048 28.5904 14.5685 28.1173 13.0234C26.7747 10.1372 24.0451 8.15039 20.9148 8.15039H15.0893C11.9581 8.15039 9.22796 10.1386 7.88571 13.0261C7.41329 14.5699 7.13682 16.3045 7.08691 18.2022C7.58396 21.5469 10.2328 24.1206 13.4015 24.1206Z"
        fill="#ABB1B8"
      />
      <path
        d="M22.6004 23.3502H13.3993C9.87971 23.3502 7 20.1754 7 16.2954C7 11.3919 10.6391 7.37988 15.0872 7.37988H20.9126C25.3606 7.37988 29 11.3918 29 16.2954C28.9999 20.1754 26.1203 23.3502 22.6004 23.3502Z"
        fill="url(#paint1_radial_456_344)"
      />
      <path
        d="M22.2085 22.6648H13.7951C10.5766 22.6648 7.94336 19.7618 7.94336 16.2138C7.94336 11.7301 11.271 8.06152 15.3385 8.06152H20.6654C24.7327 8.06152 28.0605 11.7301 28.0605 16.2138C28.0604 19.7618 25.4272 22.6648 22.2085 22.6648Z"
        fill="url(#paint2_linear_456_344)"
      />
      <path
        d="M22.2622 22.6482H13.7348C10.7344 22.6482 8.2793 19.9417 8.2793 16.6339V16.3512C8.2793 12.1711 11.3817 8.75098 15.1736 8.75098H20.8234C24.6154 8.75098 27.7175 12.1711 27.7175 16.3512V16.6339C27.7175 19.9416 25.2629 22.6482 22.2622 22.6482Z"
        fill="white"
      />
      <path
        d="M22.8477 19.0843C23.1824 19.0843 23.4564 18.9393 23.4564 18.7619C23.9901 17.0493 23.9777 15.2878 23.4564 13.4807C23.4564 13.3033 23.1824 13.1582 22.8477 13.1582C22.5131 13.1582 22.2393 13.3033 22.2393 13.4807V18.7619C22.2393 18.9393 22.5131 19.0843 22.8477 19.0843Z"
        fill="url(#paint3_radial_456_344)"
      />
      <path
        d="M13.5059 19.0824C13.1716 19.0824 12.8975 18.9375 12.8975 18.7599C12.364 17.0471 12.3763 15.2859 12.8975 13.4789C12.8975 13.3012 13.1716 13.1562 13.5059 13.1562C13.8408 13.1562 14.1147 13.3012 14.1147 13.4789V18.7599C14.1147 18.9375 13.8408 19.0824 13.5059 19.0824Z"
        fill="url(#paint4_radial_456_344)"
      />
      <g filter="url(#filter0_d_456_344)">
        <path
          d="M14.3908 24.3208L14.4297 20.7585C14.4307 20.6665 14.5375 20.6201 14.6115 20.6795L17.3168 22.8504C17.3905 22.9095 17.3688 23.0236 17.2804 23.0466C16.2099 23.326 15.5572 23.6608 14.5785 24.4171C14.5038 24.4748 14.3898 24.4167 14.3908 24.3208Z"
          fill="url(#paint5_linear_456_344)"
        />
        <path
          d="M21.3232 21.0996L18.2476 22.8565C18.1454 22.9148 18.1772 23.0929 18.2894 23.1001C19.5816 23.1831 20.1498 23.7538 21.3205 24.6815C21.3909 24.7372 21.4913 24.6761 21.4908 24.5776L21.4754 21.2005C21.475 21.1131 21.3939 21.0593 21.3232 21.0996Z"
          fill="url(#paint6_linear_456_344)"
        />
        <ellipse
          cx="0.684485"
          cy="0.635543"
          rx="0.684485"
          ry="0.635543"
          transform="matrix(0.813971 -0.562704 0.604671 0.783616 16.7979 23.1074)"
          fill="#35B5DF"
        />
      </g>
      <defs>
        <filter id="filter0_d_456_344" x="14.1635" y="20.6533" width="7.55482" height="4.50404" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.227115" />
          <feGaussianBlur stdDeviation="0.113558" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_456_344" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_456_344" result="shape" />
        </filter>
        <radialGradient
          id="paint0_radial_456_344"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.6932 10.1395) scale(15.7046 20.3654)"
        >
          <stop stopColor="#63C9F3" />
          <stop offset="0.4961" stopColor="#00B0ED" />
          <stop offset="0.7732" stopColor="#00AFEB" />
          <stop offset="0.873" stopColor="#00ABE3" />
          <stop offset="0.9439" stopColor="#00A4D9" />
          <stop offset="1" stopColor="#009BCC" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_456_344"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.9999 15.3651) scale(9.31301 10.2669)"
        >
          <stop stopColor="#63C9F3" />
          <stop offset="0.4961" stopColor="#00B0ED" />
          <stop offset="0.7732" stopColor="#00AFEB" />
          <stop offset="0.873" stopColor="#00ABE3" />
          <stop offset="0.9439" stopColor="#00A4D9" />
          <stop offset="1" stopColor="#009BCC" />
        </radialGradient>
        <linearGradient id="paint2_linear_456_344" x1="18.1921" y1="8.05695" x2="17.9616" y2="16.1806" gradientUnits="userSpaceOnUse">
          <stop offset="5.4e-07" stopColor="#DDDFE3" />
          <stop offset="0.2271" stopColor="#E8E9EB" />
          <stop offset="0.5942" stopColor="#F4F4F5" />
          <stop offset="1" stopColor="#F9F9F9" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_456_344"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.0457 16.1213) scale(1.9842 2.18743)"
        >
          <stop stopColor="#00B0ED" />
          <stop offset="0.0849" stopColor="#00ABE5" />
          <stop offset="0.2237" stopColor="#00A3D4" />
          <stop offset="0.3991" stopColor="#2995B9" />
          <stop offset="0.6042" stopColor="#4B7C92" />
          <stop offset="0.8315" stopColor="#47565F" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_456_344"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.3083 16.1193) scale(1.9842 2.18743)"
        >
          <stop stopColor="#00B0ED" />
          <stop offset="0.0849" stopColor="#00ABE5" />
          <stop offset="0.2237" stopColor="#00A3D4" />
          <stop offset="0.3991" stopColor="#2995B9" />
          <stop offset="0.6042" stopColor="#4B7C92" />
          <stop offset="0.8315" stopColor="#47565F" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient id="paint5_linear_456_344" x1="14.1396" y1="22.7086" x2="17.4973" y2="23.3713" gradientUnits="userSpaceOnUse">
          <stop offset="0.15625" stopColor="#1F7D9C" />
          <stop offset="0.553486" stopColor="#7ADDFF" />
        </linearGradient>
        <linearGradient id="paint6_linear_456_344" x1="23.4305" y1="22.6708" x2="18.3918" y2="24.2157" gradientUnits="userSpaceOnUse">
          <stop offset="0.3125" stopColor="#1F7D9C" />
          <stop offset="1" stopColor="#7ADDFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ChatbotIcon;
